module.exports = __webpack_public_path__ + "static/xianggang_yewu.7cd19cdc.jpg";